import AppDispatcher from '@reducers/app/dispatcher';
import { selectIsBulkPage } from '@reducers/app/selectors';
import { selectHasDncPhone, selectHasOnlyDncPhones } from '@reducers/contacts/selectors';
import _ from 'lodash';
import { reportDncContactViewedClientEvent } from '../../utils/BIEvents/dnc-event';
import CompaniesDispatcher from '../companies/dispatcher';
import { actions as companiesActions } from '../companies/reducer';
import { actions } from './reducer';
import { selectProspectContacts } from './selectors';
class Dispatcher {
    constructor() {
        this.actions = Object.assign(Object.assign({}, actions), { setListId: companiesActions.setListId });
    }
    fetchCompanyLid(company) {
        return CompaniesDispatcher.fetchCompanyLid(company);
    }
    setSearchEmployeesResult(result) {
        return dispatch => {
            dispatch(actions.setSearchEmployeesResult(result));
            const { company } = result || {};
            if (_.isEmpty(company)) {
                dispatch(AppDispatcher.actions.setAppDataState('empty'));
                return null;
            }
            dispatch(CompaniesDispatcher.setSearchEmployeesResult(result));
        };
    }
    /** Reports the DNC phones among the employees of a resolved company search. */
    reportDncContactsViewed() {
        return (dispatch, getState) => {
            const state = getState();
            const contacts = selectProspectContacts(state);
            const contactsWithSomeDncPhonesCount = contacts.filter(contact => selectHasDncPhone(contact)).length;
            if (!contactsWithSomeDncPhonesCount)
                return;
            reportDncContactViewedClientEvent({
                uniqueSearchId: selectIsBulkPage(state) ? state.company.requestId || '' : '',
                subPlatform: state.settings.platform,
                pageUrl: state.app.url,
                numOfContactsWithDncPhone: contactsWithSomeDncPhonesCount,
                numOfContactsWithOnlyDncPhones: contacts.filter(contact => selectHasOnlyDncPhones(contact)).length,
                isBulkSearch: true,
            });
        };
    }
    clearSearchEmployeesResult() {
        return dispatch => {
            dispatch(actions.clearSearchEmployeesResult());
        };
    }
}
const CompanyDispatcher = new Dispatcher();
export default CompanyDispatcher;
